import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';
import type {
  CardAcquirerDto,
  CardAcquirerListDto,
  CreateCardAcquirerRequest,
} from '@/types/cardReconciliation.types';

export const cardAcquirerApi = {
  /** GET /api/v1/card-acquirers — list all (active by default) */
  getList: (activeOnly = true) =>
    apiClient.get<ApiResponse<CardAcquirerListDto[]>>('/card-acquirers', { params: { activeOnly } }),

  /** GET /api/v1/card-acquirers/{id} */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CardAcquirerDto>>(`/card-acquirers/${id}`),

  /** POST /api/v1/card-acquirers */
  create: (data: CreateCardAcquirerRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/card-acquirers', data),

  /** PUT /api/v1/card-acquirers/{id} */
  update: (id: string, data: Partial<CreateCardAcquirerRequest> & { isActive?: boolean }) =>
    apiClient.put<ApiResponse<object>>(`/card-acquirers/${id}`, data),
};
